import React, { useState } from "react";
import "./DeclineRefundRequestModal.css";

const DeclineRefundRequestModal = ({
  isOpen,
  onClose,
  onSubmit,
  ticketNumber,
  refundId,
}) => {
  const [reason, setReason] = useState("");

  const handleSubmit = () => {
    if (!reason.trim()) return alert("Please enter a reason.");
    onSubmit(reason);
    setReason("");
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="refund-modal">
        <h5>Decline Refund for ticket number #{ticketNumber}</h5>
        <textarea
          placeholder="Enter reason for declining..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          rows={4}
        />
        <div className="modal-actions">
          <button onClick={handleSubmit} className="save-btn">
            Decline
          </button>
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeclineRefundRequestModal;
